/**
 * Song length in whole milliseconds. Reads the media metadata first, which is cheap for a
 * 20 MB file; full decoding is the fallback for files the element cannot report on.
 */
export async function readDurationMs(file: Blob): Promise<number> {
  try {
    return await metadataDurationMs(file);
  } catch {
    return decodeDurationMs(file);
  }
}

function metadataDurationMs(file: Blob): Promise<number> {
  return new Promise<number>((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const audio = new Audio();
    const finish = (run: () => void) => {
      URL.revokeObjectURL(url);
      run();
    };
    audio.preload = "metadata";
    audio.onloadedmetadata = () =>
      finish(() =>
        Number.isFinite(audio.duration)
          ? resolve(Math.round(audio.duration * 1000))
          : reject(new Error("No duration in metadata")),
      );
    audio.onerror = () => finish(() => reject(new Error("Metadata could not be read")));
    audio.src = url;
  });
}

async function decodeDurationMs(file: Blob): Promise<number> {
  const context = new AudioContext();
  try {
    const buffer = await context.decodeAudioData(await file.arrayBuffer());
    return Math.round(buffer.duration * 1000);
  } finally {
    await context.close();
  }
}
